export const cleanUp = () => {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("profile");
    localStorage.removeItem("menu:isOpen");
    localStorage.removeItem("impersonate");
    localStorage.removeItem("users");
  } catch (e) {
    console.error("Error during cleanup:", e);
  }
}
